import { useState, useEffect, useCallback } from 'react'
import { X, ChevronLeft, ChevronRight } from 'lucide-react'

// Helper function to convert Google Drive file ID to direct image URL
const getGoogleDriveImageUrl = (fileId: string) => {
  return `https://drive.google.com/uc?export=view&id=${fileId}`
}

// Alternative thumbnail URL (sometimes works better)
const getGoogleDriveThumbnailUrl = (fileId: string, size: number = 800) => {
  return `https://drive.google.com/thumbnail?id=${fileId}&sz=w${size}`
}

const photos = [
  {
    id: 1,
    fileId: '1pidcb7P80yn_qWQ1O3lywfR_mIaRh5TR',
    src: getGoogleDriveThumbnailUrl('1pidcb7P80yn_qWQ1O3lywfR_mIaRh5TR'),
    srcFallback: getGoogleDriveImageUrl('1pidcb7P80yn_qWQ1O3lywfR_mIaRh5TR'),
    alt: 'Engagement photo 1',
    category: 'engagement',
    aspectRatio: null
  },
  {
    id: 2,
    fileId: '1nZDOhUaQV1bCzCc2KejVFdE80oU92U_r',
    src: getGoogleDriveThumbnailUrl('1nZDOhUaQV1bCzCc2KejVFdE80oU92U_r'),
    srcFallback: getGoogleDriveImageUrl('1nZDOhUaQV1bCzCc2KejVFdE80oU92U_r'),
    alt: 'Engagement photo 2',
    category: 'engagement',
    aspectRatio: null
  },
  {
    id: 3,
    fileId: '1AKbteC8BuCT8zreC4gxscj3Lns-sUVsV',
    src: getGoogleDriveThumbnailUrl('1AKbteC8BuCT8zreC4gxscj3Lns-sUVsV'),
    srcFallback: getGoogleDriveImageUrl('1AKbteC8BuCT8zreC4gxscj3Lns-sUVsV'),
    alt: 'Engagement photo 3',
    category: 'engagement',
    aspectRatio: null
  },
  {
    id: 4,
    fileId: '12vYONNmp1bFHE5v4GjzqJO4E6593WNoT',
    src: getGoogleDriveThumbnailUrl('12vYONNmp1bFHE5v4GjzqJO4E6593WNoT'),
    srcFallback: getGoogleDriveImageUrl('12vYONNmp1bFHE5v4GjzqJO4E6593WNoT'),
    alt: 'Engagement photo 4',
    category: 'engagement',
    aspectRatio: null
  },
  {
    id: 5,
    fileId: '1v5VW88KbR7xdbqvnMvSpoynuodat3muz',
    src: getGoogleDriveThumbnailUrl('1v5VW88KbR7xdbqvnMvSpoynuodat3muz'),
    srcFallback: getGoogleDriveImageUrl('1v5VW88KbR7xdbqvnMvSpoynuodat3muz'),
    alt: 'Engagement photo 5',
    category: 'engagement',
    aspectRatio: null
  },
  {
    id: 6,
    fileId: '1RyyhVgcrHG48KAYUkpGafbibcQvC1_kP',
    src: getGoogleDriveThumbnailUrl('1RyyhVgcrHG48KAYUkpGafbibcQvC1_kP'),
    srcFallback: getGoogleDriveImageUrl('1RyyhVgcrHG48KAYUkpGafbibcQvC1_kP'),
    alt: 'Engagement photo 6',
    category: 'engagement',
    aspectRatio: null
  },
  {
    id: 7,
    fileId: '14kyhU7ceGaJbiQ1SO1YUg-rB-7iABuvX',
    src: getGoogleDriveThumbnailUrl('14kyhU7ceGaJbiQ1SO1YUg-rB-7iABuvX'),
    srcFallback: getGoogleDriveImageUrl('14kyhU7ceGaJbiQ1SO1YUg-rB-7iABuvX'),
    alt: 'Engagement photo 7',
    category: 'engagement',
    aspectRatio: null
  },
  {
    id: 8,
    fileId: '18obtjQSD-fjKfAM6aNe0gDPVZvuj3YiK',
    src: getGoogleDriveThumbnailUrl('18obtjQSD-fjKfAM6aNe0gDPVZvuj3YiK'),
    srcFallback: getGoogleDriveImageUrl('18obtjQSD-fjKfAM6aNe0gDPVZvuj3YiK'),
    alt: 'Engagement photo 8',
    category: 'engagement',
    aspectRatio: null
  },
  {
    id: 9,
    fileId: '1iSEJU_pSg_PH0SXkRfV-W2_dSc0D0G7i',
    src: getGoogleDriveThumbnailUrl('1iSEJU_pSg_PH0SXkRfV-W2_dSc0D0G7i'),
    srcFallback: getGoogleDriveImageUrl('1iSEJU_pSg_PH0SXkRfV-W2_dSc0D0G7i'),
    alt: 'Engagement photo 9',
    category: 'engagement',
    aspectRatio: null
  },
  {
    id: 10,
    fileId: '1Fx07LsgzFdXa7kxjGM7xelBX07_fvvC1',
    src: getGoogleDriveThumbnailUrl('1Fx07LsgzFdXa7kxjGM7xelBX07_fvvC1'),
    srcFallback: getGoogleDriveImageUrl('1Fx07LsgzFdXa7kxjGM7xelBX07_fvvC1'),
    alt: 'Engagement photo 10',
    category: 'engagement',
    aspectRatio: null
  },
  {
    id: 11,
    fileId: '1-8k8VNLn1_IYZm0ZQrAS-HgTP8-GIzAP',
    src: getGoogleDriveThumbnailUrl('1-8k8VNLn1_IYZm0ZQrAS-HgTP8-GIzAP'),
    srcFallback: getGoogleDriveImageUrl('1-8k8VNLn1_IYZm0ZQrAS-HgTP8-GIzAP'),
    alt: 'Engagement photo 11',
    category: 'engagement',
    aspectRatio: null
  },
  {
    id: 12,
    fileId: '1TDXKv4zD4JRLmtBSW6RIUtDvmebEh_hI',
    src: getGoogleDriveThumbnailUrl('1TDXKv4zD4JRLmtBSW6RIUtDvmebEh_hI'),
    srcFallback: getGoogleDriveImageUrl('1TDXKv4zD4JRLmtBSW6RIUtDvmebEh_hI'),
    alt: 'Engagement photo 12',
    category: 'engagement',
    aspectRatio: null
  },
  // Add more photos here by adding their Google Drive file IDs
  // Template for next photo:
  // {
  //   id: 13,
  //   fileId: 'YOUR_NEXT_FILE_ID_HERE',
  //   src: getGoogleDriveThumbnailUrl('YOUR_NEXT_FILE_ID_HERE'),
  //   srcFallback: getGoogleDriveImageUrl('YOUR_NEXT_FILE_ID_HERE'),
  //   alt: 'Engagement photo 13',
  //   category: 'engagement',
  // },
]

export function Photos() {
  const [selectedPhoto, setSelectedPhoto] = useState<number | null>(null)
  const [loadedImages, setLoadedImages] = useState<Set<number>>(new Set())
  const [imageErrors, setImageErrors] = useState<Set<number>>(new Set())
  const [imageDimensions, setImageDimensions] = useState<Record<number, { width: number; height: number; aspectRatio: number }>>({})

  const openModal = (photoId: number) => {
    setSelectedPhoto(photoId)
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden'
  }

  const closeModal = useCallback(() => {
    setSelectedPhoto(null)
    // Restore body scroll
    document.body.style.overflow = 'unset'
  }, [])

  const navigateToNext = useCallback(() => {
    if (!selectedPhoto) return
    const currentIndex = photos.findIndex(photo => photo.id === selectedPhoto)
    const nextIndex = (currentIndex + 1) % photos.length
    setSelectedPhoto(photos[nextIndex].id)
  }, [selectedPhoto, photos])

  const navigateToPrevious = useCallback(() => {
    if (!selectedPhoto) return
    const currentIndex = photos.findIndex(photo => photo.id === selectedPhoto)
    const prevIndex = currentIndex === 0 ? photos.length - 1 : currentIndex - 1
    setSelectedPhoto(photos[prevIndex].id)
  }, [selectedPhoto, photos])

  const handleImageLoad = (photoId: number, img: HTMLImageElement) => {
    if (img.naturalWidth > 0 && img.naturalHeight > 0) {
      const aspectRatio = img.naturalWidth / img.naturalHeight
      setImageDimensions(prev => ({
        ...prev,
        [photoId]: {
          width: img.naturalWidth,
          height: img.naturalHeight,
          aspectRatio
        }
      }))
    }
    setLoadedImages(prev => new Set(prev).add(photoId))
  }

  const handleImageError = (photoId: number, img?: HTMLImageElement) => {
    const photo = photos.find(p => p.id === photoId)
    
    // Try fallback URL if available and not already tried
    if (photo && 'srcFallback' in photo && img && !img.src.includes('uc?export=view')) {
      img.src = photo.srcFallback as string
      return
    }
    
    setImageErrors(prev => new Set(prev).add(photoId))
    setLoadedImages(prev => new Set(prev).add(photoId))
  }

  // Calculate dynamic height based on actual image dimensions
  const getPhotoHeight = (photoId: number, baseWidth: number = 300) => {
    const dimensions = imageDimensions[photoId]
    
    if (dimensions && dimensions.aspectRatio > 0) {
      // Calculate height to maintain aspect ratio
      const calculatedHeight = baseWidth / dimensions.aspectRatio
      return Math.max(200, Math.min(500, calculatedHeight))
    }
    
    // Fallback to varied static heights while loading
    const fallbackHeights = [280, 350, 320, 380, 300, 400, 260, 340, 360, 290, 330, 370]
    return fallbackHeights[photoId % fallbackHeights.length]
  }

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!selectedPhoto) return
      
      switch (e.key) {
        case 'ArrowRight':
          e.preventDefault()
          navigateToNext()
          break
        case 'ArrowLeft':
          e.preventDefault()
          navigateToPrevious()
          break
        case 'Escape':
          e.preventDefault()
          closeModal()
          break
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [selectedPhoto, navigateToNext, navigateToPrevious, closeModal])

  const selectedPhotoData = photos.find(photo => photo.id === selectedPhoto)
  const currentPhotoIndex = selectedPhoto ? photos.findIndex(photo => photo.id === selectedPhoto) : -1

  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-50 via-white to-neutral-100">
      <div className="section-padding">
        <div className="container-max">
          {/* Modern Hero Header */}
          <div className="text-center mb-20">
            <h1 className="text-4xl font-serif text-primary-900 mb-4">
              Engagement Photos
            </h1>
          </div>

          {/* Clean Masonry Gallery */}
          <div className="columns-1 md:columns-2 lg:columns-3 xl:columns-4 gap-4">
            {photos.map((photo) => {
              const photoHeight = getPhotoHeight(photo.id)
              
              return (
                <div
                  key={photo.id}
                  className="relative cursor-pointer overflow-hidden rounded-2xl shadow-lg break-inside-avoid mb-4"
                  style={{ 
                    height: `${photoHeight}px`,
                    transition: 'height 0.3s ease-out'
                  }}
                  onClick={() => openModal(photo.id)}
                > 
                  {/* Loading skeleton */}
                  {!loadedImages.has(photo.id) && !imageErrors.has(photo.id) && (
                    <div className="absolute inset-0 bg-gradient-to-r from-neutral-200 via-neutral-300 to-neutral-200">
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-12 h-12 border-4 border-primary-300 border-t-primary-600 rounded-full animate-spin" />
                      </div>
                    </div>
                  )}

                  {/* Error state */}
                  {imageErrors.has(photo.id) && (
                    <div className="absolute inset-0 bg-gradient-to-br from-neutral-100 to-neutral-200 flex items-center justify-center rounded-2xl">
                      <div className="text-center text-neutral-500 p-6">
                        <div className="w-16 h-16 bg-neutral-300 rounded-full flex items-center justify-center mx-auto mb-4">
                          <X className="w-8 h-8" />
                        </div>
                        <p className="text-sm font-medium">Image unavailable</p>
                        <p className="text-xs mt-1 opacity-75">Check sharing permissions</p>
                      </div>
                    </div>
                  )}

                  {/* Main image */}
                  <img
                    src={photo.src}
                    alt={photo.alt}
                    className={`w-full h-full object-cover ${
                      loadedImages.has(photo.id) && !imageErrors.has(photo.id) ? 'opacity-100' : 'opacity-0'
                    }`}
                    onLoad={(e) => handleImageLoad(photo.id, e.target as HTMLImageElement)}
                    onError={(e) => handleImageError(photo.id, e.target as HTMLImageElement)}
                    loading="lazy"
                  />
                </div>
              )
            })}
          </div>

          {/* Enhanced Modal with Modern Glass Morphism */}
          {selectedPhoto && selectedPhotoData && (
            <div 
              className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 glass-effect"
              onClick={closeModal}
            >
              {/* Modern close button */}
              <button
                onClick={closeModal}
                className="absolute top-8 right-8 bg-white/10 glass-effect rounded-xl p-3 text-white z-20 border border-white/20 shadow-xl"
                aria-label="Close modal"
              >
                <X className="h-6 w-6" />
              </button>

              {/* Enhanced navigation buttons */}
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  navigateToPrevious()
                }}
                className={`absolute left-8 top-1/2 transform -translate-y-1/2 z-20 bg-white/10 glass-effect rounded-xl p-4 text-white border border-white/20 shadow-xl ${
                  photos.length <= 1 ? 'opacity-0 pointer-events-none' : 'opacity-100'
                }`}
                aria-label="Previous photo"
                disabled={photos.length <= 1}
              >
                <ChevronLeft className="h-8 w-8" />
              </button>

              <button
                onClick={(e) => {
                  e.stopPropagation()
                  navigateToNext()
                }}
                className={`absolute right-8 top-1/2 transform -translate-y-1/2 z-20 bg-white/10 glass-effect rounded-xl p-4 text-white border border-white/20 shadow-xl ${
                  photos.length <= 1 ? 'opacity-0 pointer-events-none' : 'opacity-100'
                }`}
                aria-label="Next photo"
                disabled={photos.length <= 1}
              >
                <ChevronRight className="h-8 w-8" />
              </button>

              {/* Enhanced image container */}
              <div 
                className="relative max-w-6xl max-h-full p-8"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={selectedPhotoData.src}
                  alt={selectedPhotoData.alt}
                  className="max-w-full max-h-[80vh] object-contain rounded-xl shadow-2xl"
                  loading="eager"
                />
                
                {/* Modern photo counter */}
                <div className="absolute -bottom-16 left-1/2 transform -translate-x-1/2 text-center">
                  <div className="bg-white/10 glass-effect rounded-xl px-6 py-3 text-white border border-white/20 shadow-xl">
                    <span className="text-lg font-semibold">
                      {currentPhotoIndex + 1} of {photos.length}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
} 